(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["btf-announcement"] && !Shopify.designMode) return;
  try {
    
  /* The review claim shows the live count on every page. snippets/btf-head.liquid publishes
     Judge.me's aggregate from a shop metafield; the wording either side of the number is the
     merchant's and is kept. Nothing happens without that data. */
  (function () {
    var data = window.btfReviewData;
    var count = data && parseInt(data.number_of_reviews, 10);
    if (!count) return;
    for (var el of document.querySelectorAll('[data-btf-review-count]')) {
      el.textContent = count.toLocaleString('en-GB') +
        (el.getAttribute('data-btf-review-count-suffix') || ' verified reviews');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-collection-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const wrap = document.querySelector('.btf-collection-more');
      const list = document.querySelector('results-list');
      if (!wrap || !list) return;
      const button = wrap.querySelector('.btf-collection-more__button');
      if (!button) return;
      const label = button.textContent.trim() || 'Load more';

      const filtersTitle = (wrap.dataset.filtersTitle || '').trim();
      const clearLabel = (wrap.dataset.clearLabel || '').trim();
      const countOne = (wrap.dataset.countOne || '').trim();
      const countMany = (wrap.dataset.countMany || '').trim();
      const sortLabels = new Map(
        (wrap.dataset.sortLabels || '')
          .split(/[\n,]/)
          .map((line) => line.split('='))
          .filter((pair) => pair.length === 2)
          .map(([key, value]) => [key.trim(), value.trim()])
      );

      const grid = () => list.querySelector('[ref="grid"]');
      const sentinel = () => list.querySelector('[ref="viewMoreNext"]');
      const total = () => {
        const form = document.querySelector('[data-results-count]');
        const count = form ? Number(form.getAttribute('data-results-count')) : Number(wrap.dataset.total || 0);
        return Number.isFinite(count) ? count : 0;
      };
      const currentPage = () => Number(new URL(window.location.href).searchParams.get('page') || 1);

      const hideSentinel = () => {
        const target = sentinel();
        if (target && target.style.display !== 'none') target.style.display = 'none';
      };

      // The rail is headed "Filter", not Horizon's "Filters".

      // The clear link is worded per screen: "Clear" on screen 04, "Clear all" on screen 05.
      const renameClear = () => {
        if (!clearLabel) return;
        for (const node of list.querySelectorAll('.facets__clear-all-link')) {
          if (node.textContent.trim() !== clearLabel) node.textContent = clearLabel;
        }
      };

      // "45 items" reads "45 panels" on screen 04 and "45 products" on screen 05 — the design
      // names what is being counted, and the noun is a setting because it differs per collection.
      const renameCount = () => {
        if (!countOne || !countMany) return;
        for (const node of list.querySelectorAll('.products-count-wrapper [role="status"]')) {
          const text = node.textContent.trim();
          if (!text) continue;
          const next = text.replace(/([\d,.]+)(\s+)(\S+)$/, (all, number, space) => {
            const value = parseFloat(number.replace(/[,\s]/g, ''));
            return number + space + (value === 1 ? countOne : countMany);
          });
          if (next !== text) node.textContent = next;
        }
      };

      // "Best selling" reads "Most popular" wherever the sort value is relabelled.
      const renameSort = () => {
        if (!sortLabels.size) return;
        for (const option of list.querySelectorAll('.sorting-filter__option, option')) {
          const value = option.value || option.getAttribute('value') || option.dataset.value;
          const next = sortLabels.get(value);
          if (!next) continue;
          const target = option.querySelector('.sorting-filter__label') || option;
          if (target.textContent.trim() !== next) target.textContent = next;
        }
        const selected = list.querySelector('.sorting-filter__input:checked');
        const current = selected
          ? sortLabels.get(selected.value)
          : sortLabels.get(list.querySelector('option[selected]')?.value || '');
        if (!current) return;
        for (const status of list.querySelectorAll('.sorting-filter .facets__status')) {
          if (status.textContent.trim() !== current) status.textContent = current;
        }
      };

      const update = () => {
        const items = grid();
        const target = sentinel();
        const shown = items ? items.querySelectorAll('.product-grid__item:not(.btf-collection-promo__item)').length : 0;
        const remaining = Math.max(0, total() - shown);
        const lastPage = items ? Number(items.dataset.lastPage || 1) : 1;
        if (!target || remaining <= 0 || currentPage() >= lastPage) {
          button.hidden = true;
          return;
        }
        button.hidden = false;
        button.disabled = false;
        button.textContent = label + ' — ' + remaining + ' remaining';
      };

      button.addEventListener('click', () => {
        const target = sentinel();
        if (!target) return;
        button.disabled = true;
        // Revealing the sentinel lets Horizon's intersection observer append the next page.
        target.style.display = 'block';
        window.setTimeout(() => {
          hideSentinel();
          update();
        }, 4000);
      });

      // Mobile: a "Sort" cell beside Horizon's "Filter" toggle, opening the drawer at its sort options.
      const addSort = () => {
        const wrapper = list.querySelector('.facets-toggle .facets-mobile-wrapper');
        const drawer = document.getElementById('filters-drawer');
        if (!wrapper || !drawer || wrapper.querySelector('.btf-facets-sort')) return;
        const sort = document.createElement('button');
        sort.type = 'button';
        sort.className = 'btf-facets-sort';
        sort.textContent = 'Sort';
        sort.addEventListener('click', () => {
          if (typeof drawer.open === 'function') drawer.open();
          else drawer.setAttribute('open', '');
          window.requestAnimationFrame(() => {
            const details = drawer.querySelector('.sorting-filter details');
            if (details) {
              details.open = true;
              details.scrollIntoView({ block: 'start' });
            }
          });
        });
        wrapper.appendChild(sort);
      };

      const apply = () => {
        hideSentinel();
        addSort();
        renameSort();
        renameCount();
        renameClear();
        update();
      };

      const observer = new MutationObserver(() => {
        observer.disconnect();
        apply();
        observer.observe(list, { childList: true, subtree: true });
      });

      apply();
      observer.observe(list, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-collection-promo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const promo = document.querySelector('.btf-collection-promo');
      const list = document.querySelector('results-list');
      if (!promo || !list) return;

      const position = Math.max(1, Number(promo.dataset.position || 6));
      const item = document.createElement('li');
      item.className = 'product-grid__item btf-collection-promo__item';
      item.id = 'btf-collection-promo-item';
      item.appendChild(promo);

      const place = () => {
        const grid = list.querySelector('[ref="grid"]');
        if (!grid) return;
        // Horizon's grid also holds a script node, so count the product cards only
        const cards = [...grid.querySelectorAll(':scope > .product-grid__item')].filter((card) => card !== item);
        if (!cards.length) return;
        const before = cards[position - 1];
        if (before) {
          if (before.previousElementSibling !== item) grid.insertBefore(item, before);
        } else if (grid.lastElementChild !== item) {
          grid.appendChild(item);
        }
      };

      const observer = new MutationObserver(() => {
        observer.disconnect();
        place();
        observer.observe(list, { childList: true, subtree: true });
      });

      place();
      observer.observe(list, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-collection-rail-note"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const note = document.querySelector('.btf-collection-rail-note');
      const list = document.querySelector('results-list');
      if (!note || !list) return;

      const place = () => {
        const rail = list.querySelector('.facets--vertical:not(.facets--drawer) .facets__filters-wrapper');
        if (!rail || rail.lastElementChild === note) return;
        rail.appendChild(note);
      };

      const observer = new MutationObserver(() => {
        observer.disconnect();
        place();
        observer.observe(list, { childList: true, subtree: true });
      });

      place();
      observer.observe(list, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-cyo-film"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.btf-cyo-film__frame').forEach((frame) => {
    const video = frame.querySelector('video');
    const button = frame.querySelector('[data-btf-film-button]');
    if (!video || !button || button.dataset.bound) return;
    button.dataset.bound = '1';
    const idle = button.textContent;
    const sync = () => {
      const playing = !video.paused && !video.ended;
      button.textContent = playing ? '‖  Pause' : idle;
      button.classList.toggle('is-playing', playing);
      button.setAttribute('aria-label', playing ? 'Pause the video' : 'Play the video');
    };
    button.addEventListener('click', () => {
      if (video.paused || video.ended) {
        video.controls = true;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    ['play', 'pause', 'ended'].forEach((ev) => video.addEventListener(ev, sync));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-help-group"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.btfHelpAccordionInit) return;
    window.btfHelpAccordionInit = true;

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var button = item.querySelector('.btf-help-q__summary');
      if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('.btf-help-q__summary') : null;
      if (!button) return;
      var item = button.closest('.btf-help-q');
      if (!item) return;
      setOpen(item, !item.classList.contains('is-open'));
    });

    // Deep links (#h-del-q17 or a hash matching a question id) open that row.
    function openFromHash() {
      if (!location.hash) return;
      var target = document.getElementById(location.hash.slice(1));
      var item = target && target.closest ? target.closest('.btf-help-q') : null;
      if (item) setOpen(item, true);
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-home-collections"] && !Shopify.designMode) return;
  try {
    
  class BtfRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      if (!this.track) return;
      const prev = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      if (prev) prev.addEventListener('click', () => { this.stop(); this.scroll(-1); });
      if (next) next.addEventListener('click', () => { this.stop(); this.scroll(1); });
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) =>
        this.track.addEventListener(type, () => this.stop(), { passive: true })
      );
      this.track.addEventListener('pointerenter', () => this.stop());
      // The design snaps the first card flush to the viewport edge (the track's own padding
      // becomes the lead-in that mandatory snapping hides).
      this.track.scrollLeft = this.pad();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && !reduced) this.auto();
    }

    disconnectedCallback() {
      this.stop();
    }

    pad() {
      return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
    }

    step() {
      const card = this.track.children[0];
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scroll(dir) {
      const step = this.step();
      if (!step) return;
      const pad = this.pad();
      const max = this.track.scrollWidth - this.track.clientWidth;
      const index = Math.round((this.track.scrollLeft - pad) / step);
      const count = this.track.children.length;
      let target = index + dir;
      if (target >= count || (dir > 0 && this.track.scrollLeft >= max - 2)) target = 0;
      if (target < 0) target = count - 1;
      this.track.scrollTo({ left: Math.min(max, pad + target * step), behavior: 'smooth' });
    }

    auto() {
      this.on = true;
      this.observer = new IntersectionObserver(([entry]) => {
        if (!this.on) return;
        if (entry.isIntersecting) {
          if (!this.timer) this.timer = setInterval(() => { if (!document.hidden) this.scroll(1); }, 4200);
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, { threshold: 0.35 });
      this.observer.observe(this.track);
    }

    stop() {
      this.on = false;
      clearInterval(this.timer);
      this.timer = null;
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('btf-rail')) {
    customElements.define('btf-rail', BtfRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-home-planners"] && !Shopify.designMode) return;
  try {
    
  class BtfPlannerGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.btf-home-planners__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.index = 0;
      this.timer = null;
      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => { this.play(false); this.go(-1); });
      if (next) next.addEventListener('click', () => { this.play(false); this.go(1); });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.play(false); this.set(i); }));
      this.addEventListener('mouseenter', () => this.play(false));
      this.addEventListener('mouseleave', () => this.play(true));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.play(true);
    }

    disconnectedCallback() {
      this.play(false);
    }

    set(i) {
      this.index = i;
      this.slides.forEach((slide, k) => slide.classList.toggle('is-active', k === i));
      this.dots.forEach((dot, k) => {
        dot.classList.toggle('is-active', k === i);
        if (k === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    go(dir) {
      const n = this.slides.length;
      if (!n) return;
      this.set((((this.index + dir) % n) + n) % n);
    }

    play(on) {
      clearInterval(this.timer);
      this.timer = null;
      if (!on || this.reduced || this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
      this.timer = setInterval(() => {
        if (document.hidden) return;
        const r = this.getBoundingClientRect();
        const vh = window.innerHeight || 800;
        if (r.bottom < 0 || r.top > vh) return;
        this.go(1);
      }, 3000);
    }
  }

  if (!customElements.get('btf-planner-gallery')) {
    customElements.define('btf-planner-gallery', BtfPlannerGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-password-holding"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-live-at]');
    if (!root) return;
    var target = new Date(root.dataset.liveAt).getTime();
    if (!target || isNaN(target)) return;

    var cells = {
      d: root.querySelector('[data-d]'),
      h: root.querySelector('[data-h]'),
      m: root.querySelector('[data-m]'),
      s: root.querySelector('[data-s]'),
    };
    var label = root.querySelector('[data-live-label]');
    var pad = function (n) { return String(n).padStart(2, '0'); };

    // The eyebrow reads UK time whatever time zone the visitor is in.
    if (label) {
      try {
        var opts = window.matchMedia('(max-width: 989px)').matches
          ? { weekday: 'short', day: 'numeric', month: 'short' }
          : { weekday: 'long', day: 'numeric', month: 'long' };
        opts.timeZone = 'Europe/London';
        var when = new Date(target);
        var day = new Intl.DateTimeFormat('en-GB', opts).format(when);
        var time = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London', hour: 'numeric', minute: '2-digit', hour12: true,
        }).format(when).replace(':00', '').replace(/\s/g, '').toLowerCase();
        label.textContent = time + ', ' + day;
      } catch (e) {
        /* leave the server-rendered fallback in place */
      }
    }

    var timer;
    function tick() {
      var left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (cells.d) cells.d.textContent = pad(Math.floor(left / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor((left % 86400) / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (cells.s) cells.s.textContent = pad(left % 60);
      if (!left) {
        if (label) label.textContent = 'now';
        clearInterval(timer);
      }
    }
    timer = setInterval(tick, 1000);
    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-quotes-specs"] && !Shopify.designMode) return;
  try {
    
  class BtfReviewRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-review]'));
      this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
      this.at = 0;
      this.paused = false;
      this.stopped = false;
      if (this.slides.length < 2) return;

      this.addEventListener('click', (e) => {
        const dot = e.target instanceof Element && e.target.closest('[data-review-dot]');
        if (!dot) return;
        // The reader has chosen: stay on their choice
        this.stopped = true;
        this.show(Number(dot.dataset.reviewDot));
      });
      const pause = () => (this.paused = true);
      const resume = () => (this.paused = this.matches(':hover') || this.contains(document.activeElement));
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', () => setTimeout(resume));

      // The theme editor shows the review being edited
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex((s) => s.dataset.shopifyEditorBlock && s.dataset.shopifyEditorBlock.includes(e.detail.blockId));
        if (i < 0) return;
        this.stopped = true;
        this.show(i);
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const seconds = Math.max(4, Number(this.dataset.seconds) || 8);
      this.timer = setInterval(() => {
        if (this.stopped || this.paused || document.hidden) return;
        this.show((this.at + 1) % this.slides.length);
      }, seconds * 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    show(i) {
      this.at = i;
      this.slides.forEach((s, n) => {
        s.classList.toggle('is-on', n === i);
        if (n === i) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((d, n) => d.setAttribute('aria-pressed', n === i ? 'true' : 'false'));
    }
  }

  if (!customElements.get('btf-review-rotator')) customElements.define('btf-review-rotator', BtfReviewRotator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-reviews-heading"] && !Shopify.designMode) return;
  try {
    
  /* The rating, the review count and the star breakdown come from Judge.me, so they cannot
     drift as reviews arrive — the bar said 630 while the page said 632 when they were typed.

     The source is the object Judge.me's own all-reviews widget parks on the page:
     window.jdgm.data.allReviewsWidgetV2025, which carries number_of_reviews, average_rating
     and a histogram of frequency and percentage per star. That is set from a shop metafield in
     the widget's Liquid, so it is there long before the widget finishes drawing itself.

     Every step is a no-op if Judge.me has not answered: the typed settings stand, so the page
     is never blank, zeroed or mid-update. */
  (function () {
    var UNDER_ONE = 'under 1%';

    function read() {
      var d = window.jdgm && window.jdgm.data && window.jdgm.data.allReviewsWidgetV2025;
      if (!d) return null;
      var count = parseInt(d.number_of_reviews, 10);
      var average = parseFloat(d.average_rating);
      if (!count || !average) return null;
      return { count: count, average: average, histogram: d.histogram || [] };
    }

    function line(entry) {
      var n = parseInt(entry.frequency, 10) || 0;
      var pct = Number(entry.percentage);
      // Judge.me rounds to whole percents, so a real but tiny share arrives as 0.
      var shown = pct >= 1 ? Math.round(pct) + '%' : (n > 0 ? UNDER_ONE : '0%');
      return n.toLocaleString('en-GB') + ' — ' + shown;
    }

    function apply(data) {
      var avg = document.querySelector('[data-btf-rating-average]');
      if (avg) avg.textContent = data.average.toFixed(1);

      var count = document.querySelector('[data-btf-rating-count]');
      if (count) count.textContent = data.count.toLocaleString('en-GB');

      var fiveStar = null;
      for (var entry of data.histogram) {
        var cell = document.querySelector('[data-btf-star="' + entry.rating + '"]');
        if (cell) cell.textContent = line(entry);
        if (Number(entry.rating) === 5) fiveStar = Math.round(Number(entry.percentage));
      }

      // "verified reviews · 93% five star" is one free-text label, so only the figure inside
      // it is replaced. The wording either side is the merchant's.
      var label = document.querySelector('[data-btf-rating-label]');
      if (label && fiveStar) {
        label.textContent = label.textContent.replace(/\d+\s*%/, fiveStar + '%');
      }

      // The same figure appears in the claims bar on every page of the site.
      for (var el of document.querySelectorAll('[data-btf-review-count]')) {
        el.textContent = data.count.toLocaleString('en-GB') +
          (el.getAttribute('data-btf-review-count-suffix') || ' verified reviews');
      }
    }

    var started = Date.now();
    var timer = setInterval(function () {
      var data = read();
      if (data) {
        apply(data);
        clearInterval(timer);
      } else if (Date.now() - started > 15000) {
        clearInterval(timer);
      }
    }, 300);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btf-search-refine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const band = document.querySelector('.btf-search-refine');
      if (!band) return;

      // The design draws a Search button beside the field; Horizon's search input block has none.
      const form = document.querySelector('.search-page__header .search-page-input__parent');
      const label = (band.dataset.searchLabel || '').trim();
      if (form && label && !form.querySelector('.btf-search-submit')) {
        const button = document.createElement('button');
        button.type = 'submit';
        button.className = 'btf-btn btf-search-submit';
        button.textContent = label;
        form.appendChild(button);
      }

      // A tag is current when every one of its filter pairs is in the address bar.
      const params = new URLSearchParams(window.location.search);
      const tags = [...band.querySelectorAll('.btf-search-refine__tag')];
      let matched = false;

      for (const tag of tags) {
        const refine = (tag.dataset.refine || '').trim();
        if (!refine) continue;
        const wanted = new URLSearchParams(refine);
        let active = true;
        for (const [key, value] of wanted) {
          if (!params.getAll(key).includes(value)) active = false;
        }
        tag.classList.toggle('is-active', active);
        if (active) matched = true;
      }

      for (const tag of tags) {
        if ((tag.dataset.refine || '').trim()) continue;
        tag.classList.toggle('is-active', !matched);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
